"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectEntity = void 0;
var isAnchorElement = function (el) {
    return typeof el === "object" && el.hasAttribute("href") && el.tagName.toLowerCase() === "a";
};
/**
 * find entity info
 */
var collectEntity = function (element, config) {
    var _a;
    if (config === void 0) { config = {}; }
    var _b = config.attributePrefix, attributePrefix = _b === void 0 ? "data-octavius-" : _b, _c = config.breakpointGroups, breakpointGroups = _c === void 0 ? 50 : _c, _d = config.selectors, selectors = _d === void 0 ? {
        grid: '.grid',
        grid_container: '.grid-container',
        grid_slot: '.grid-slot',
        grid_box: '.grid-box',
        list_item: 'li',
    } : _d;
    /**
     * now get the entity datas
     */
    var entity = {};
    /**
     * get url if there is a href
     * can be overwritten by
     * data-octavius-content_url
     */
    if (isAnchorElement(element)) {
        /**
         * distinguish external and internal links
         */
        if (window.location.hostname === element.hostname) {
            entity.content_url = element.pathname;
        }
        else {
            entity.content_url = element.hostname + element.pathname;
        }
    }
    /**
     * location path as parent url
     */
    if (element != window.document.body)
        entity.parent_url = window.location.pathname;
    /**
     * get grid values if there is a grid around
     */
    var grid = get_closest(element, selectors.grid);
    if (grid) {
        /**
         * can be overwritten by
         * data-octavius-grid_container_number
         * data-octavius-grid_slot_number
         * data-octavius-grid_box_number
         */
        var container = get_closest(element, selectors.grid_container);
        if (container) {
            entity.grid_container_number = get_index(container) + 1;
        }
        var slot = get_closest(element, selectors.grid_slot);
        if (slot) {
            entity.grid_slot_number = get_index(slot) + 1;
        }
        var box = get_closest(element, selectors.grid_box);
        if (box) {
            entity.grid_box_number = get_index(box) + 1;
        }
        /**
         * wild guess for list number
         * can be overwritten by
         * data-octavius-list_number
         */
        var listItem = get_closest(element, selectors.list_item);
        if (listItem) {
            entity.list_number = get_index(listItem) + 1;
        }
    }
    /**
     * calculate screen number
     * can be overwritten by
     * data-octavius-screen_number
     */
    if (typeof element !== typeof undefined) {
        var bodyRect = document.body.getBoundingClientRect();
        var elementTopOffset = 0;
        var offsetElement = element;
        do {
            elementTopOffset += ((_a = offsetElement === null || offsetElement === void 0 ? void 0 : offsetElement.offsetTop) !== null && _a !== void 0 ? _a : 0) || 0;
            offsetElement = offsetElement === null || offsetElement === void 0 ? void 0 : offsetElement.offsetParent;
        } while (offsetElement);
        entity.screen_number = Math.ceil(elementTopOffset / bodyRect.height);
    }
    /**
     * last step get all octavius attributes that are hardcoded on element
     * those can override the wild guesses
     */
    if (typeof element !== typeof undefined) {
        for (var i = element.attributes.length - 1; i >= 0; i--) {
            if (element.attributes[i].name.indexOf(attributePrefix) ===
                0) {
                var key = element.attributes[i].name.replace(attributePrefix, '');
                entity[key] = element.attributes[i].value;
            }
        }
    }
    /**
     * breakpoints floor to 100px steps
     */
    entity.breakpoint = "".concat((Math.floor(window.innerWidth / breakpointGroups) * breakpointGroups), "px");
    return entity;
};
exports.collectEntity = collectEntity;
/**
 * find closest parent with selector
 */
function get_closest(el, selector) {
    if (typeof el === typeof undefined)
        return null;
    // traverse parents
    while (el !== null) {
        var candidate = el.parentElement;
        if (candidate !== null && candidate.matches(selector)) {
            return candidate;
        }
        el = candidate;
    }
    return null;
}
/**
 * get index of node
 * @param {Element} node
 * @return {number}
 */
function get_index(node) {
    var _a;
    var children = (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.childNodes;
    if (children) {
        var num = 0;
        for (var i = 0; i < children.length; i++) {
            if (children[i] == node)
                return num;
            if (children[i].nodeType == 1)
                num++;
        }
    }
    return 0;
}
